import { LinkReferralDto, ReferralDto } from '@coretava/api/events-service';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import { i18next } from '@gamiphy/react-i18n';
import { formatDate } from '@gamiphy/utils/date';
import {
  Slide,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { observer } from 'mobx-react';
import React from 'react';
import { calculateBoosterEndDate, formatRefereeReward } from '../../cashback/utils';
import { Popup } from '../../popup';
import InviteOptions from './InviteOptions';

// Create slide transition for the referral popup
const Transition = React.forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Slide direction="up" ref={ref} {...props} />);

type Props={
    open: boolean,
    onChangeState: () => void,
    appReferral: ReferralDto,
    linkReferral?: LinkReferralDto,
}

const InviteOptionsPopup: React.FC<Props> = ({
  open,
  onChangeState,
  appReferral,
  linkReferral,
}) => {
  const whatsAppMessage = React.useMemo(() => (linkReferral ? `${i18next.t('referral.booster.whatsAppLink', {
    defaultValue: 'Join me at {{programName}} and enjoy {{reward}} off your first purchase valid until {{boosterExpiryDate}}, plus access to exclusive discounts! Click here to get started: {{referralLink}}',
    programName: AppStore.app.name,
    reward: CampaignUserStore.referralCampaignUser?.campaign ? formatRefereeReward(CampaignUserStore.referralCampaignUser?.campaign) : undefined,
    boosterExpiryDate: CampaignUserStore.referralCampaignUser?.campaign ? formatDate(calculateBoosterEndDate(CampaignUserStore.referralCampaignUser?.campaign)) : undefined,
    referralLink: linkReferral.link,
  })}` : ''), [linkReferral, AppStore.app, CampaignUserStore.referralCampaignUser]);
  return (
    <Popup
      fullWidth
      open={open}
      PaperProps={{
        sx: {
          width: '100%',
          position: 'fixed',
          bottom: 0,
          borderRadius: 0,
        },
      }}
      onClose={onChangeState}
      TransitionComponent={Transition}
    >
      <InviteOptions
        onChangeState={onChangeState}
        appReferral={appReferral}
        linkReferral={linkReferral}
        whatsAppMessage={whatsAppMessage}
      />
    </Popup>
  );
};

export default observer(InviteOptionsPopup);
